"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class ParentChildRelationshipRejectedError extends client_library_1.ExtendableError {
    constructor() {
        super('You are unable to reinvite this parent');
    }
}
exports.default = ParentChildRelationshipRejectedError;
//# sourceMappingURL=ParentChildRelationshipRejectedError.js.map